export const environment = [
  "localhost",
  "sandbox",
  "ci",
  "preprod",
  "production",
] as const;

export type Environment = typeof environment[number];
